import { useQuery } from '@tanstack/react-query'
import { checkDuplicateServiceAreaOverrideRule } from '../../../api/plan-service-area-override-rules-api'
import type { CheckDuplicateServiceAreaOverrideRuleQueryDto } from '../../../api/dto/plan-service-area-override-rules.dto'

export const SERVICE_AREA_OVERRIDE_CHECK_DUPLICATE_QUERY_KEY =
  'serviceAreaOverrideCheckDuplicate'

export function useCheckDuplicateServiceAreaOverrideRule(
  query: Partial<CheckDuplicateServiceAreaOverrideRuleQueryDto>,
  enabled = true
) {
  const isComplete =
    query.year != null &&
    query.issuerId != null &&
    query.state != null &&
    query.serviceAreaId != null &&
    query.hiosPlanId != null &&
    query.countyCode != null &&
    query.zipcode != null

  return useQuery({
    queryKey: [SERVICE_AREA_OVERRIDE_CHECK_DUPLICATE_QUERY_KEY, query],
    queryFn: () =>
      checkDuplicateServiceAreaOverrideRule(
        query as CheckDuplicateServiceAreaOverrideRuleQueryDto
      ),
    enabled: enabled && isComplete,
    staleTime: 10_000,
  })
}
